import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Sparkles, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingSection() {
  const handlePurchaseClick = () => {
    trackAddToCart({
      content_name: 'Agenda Antiansiedad',
      content_ids: ['44402687279206'],
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
    window.location.href = 'https://momentumdigitalpro.com/cart/44402687279206:1';
  };
  return <section id="pricing" className="py-24 px-4 bg-[#FAF8F5] relative overflow-hidden" data-id="element-129">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#C4836A]/5 rounded-full blur-3xl pointer-events-none" data-id="element-130"></div>

      <div className="max-w-xl mx-auto relative z-10" data-id="element-131">
        <FadeIn data-id="element-132">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-[#E5E0D8]" data-id="element-133">
            <div className="bg-[#3D3D3D] p-6 text-center" data-id="element-134">
              <h3 className="text-white font-serif text-2xl" data-id="element-135">
                Agenda Antiansiedad
              </h3>
              <p className="text-gray-300 text-sm mt-1" data-id="element-136">Protocolo 3×3×3</p>
            </div>

            <div className="p-8 md:p-12 text-center" data-id="element-137">
              <p className="text-[#5A6B5A] mb-6" data-id="element-138">
                Si lo que necesitas es un plan que quepa en tu vida real.
              </p>

              <div className="flex flex-col items-center justify-center mb-8" data-id="element-139">
                <div className="flex items-center gap-2 mb-1" data-id="element-140">
                  <span className="text-xl text-[#5A6B5A] line-through opacity-60" data-id="element-141">
                    $12.99 USD
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-142">
                  <span className="text-5xl font-bold text-[#C4836A]" data-id="element-143">
                    $6.39
                  </span>
                  <span className="text-xl text-[#5A6B5A] self-end mb-2" data-id="element-144">
                    USD
                  </span>
                </div>
                <span className="mt-2 inline-block px-3 py-1 bg-[#C4836A]/10 text-[#C4836A] text-sm font-medium rounded-full" data-id="element-145">
                  ¡Oferta especial!
                </span>
              </div>

              <div className="space-y-4 mb-8 text-left max-w-xs mx-auto" data-id="element-146">
                <div className="flex items-center gap-3 text-[#5A6B5A]" data-id="element-147">
                  <Sparkles size={18} className="text-[#C4836A]" data-id="element-148" />
                  <span data-id="element-149">Acceso inmediato (PDF)</span>
                </div>
                <div className="flex items-center gap-3 text-[#5A6B5A]" data-id="element-150">
                  <Sparkles size={18} className="text-[#C4836A]" data-id="element-151" />
                  <span data-id="element-152">Guiones y plantillas incluidas</span>
                </div>
                <div className="flex items-center gap-3 text-[#5A6B5A]" data-id="element-153">
                  <Sparkles size={18} className="text-[#C4836A]" data-id="element-154" />
                  <span data-id="element-155">Plan de 14 días paso a paso</span>
                </div>
              </div>

              <Button size="lg" fullWidth className="text-lg shadow-xl shadow-[#C4836A]/20" onClick={handlePurchaseClick} data-id="element-156">
                Descargar Ahora
              </Button>

              <p className="mt-6 text-sm text-[#8B9E8B] font-medium" data-id="element-157">
                Hazlo 14 días. Sin hacerlo perfecto.
              </p>
            </div>

            <div className="bg-[#FAF8F5] p-4 text-center border-t border-[#E5E0D8]" data-id="element-158">
              <div className="flex items-center justify-center gap-2 text-xs text-[#5A6B5A]" data-id="element-159">
                <ShieldCheck size={14} data-id="element-160" />
                <span data-id="element-161">Pago 100% seguro y encriptado</span>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} className="mt-12 text-center" data-id="element-162">
          <p className="text-sm text-[#5A6B5A] opacity-60" data-id="element-163">
            © 2024 Agenda Antiansiedad. Todos los derechos reservados. <br data-id="element-164" />
            Este producto no sustituye la terapia profesional.
          </p>
        </FadeIn>
      </div>
    </section>;
}